import React from 'react';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useUserContext } from 'contexts';
import { CountryCodeList } from 'types/countries';
import styles from '../style.module.scss';
import { DesktopNavigation } from '@core/ui/navigation';

// Dynamically import the CountrySwitcher component to reduce initial bundle size
const CountrySwitcher = dynamic(() => import('components/country-switcher'), {
  loading: () => <></>,
  ssr: false, // Disable server-side rendering for this component
});

/**
 * CountrySwitcherSection Component
 * Renders a country selection dropdown in the navigation menu
 * Allows users to switch between US and Canadian versions of the site
 */
const CountrySwitcherSection = () => {
  const { siteLocation } = useUserContext();
  const isUsSite = siteLocation === CountryCodeList.UNITED_STATES;

  // Custom trigger component for the country switcher dropdown
  const countrySwitcherTrigger = (
    <>
      <Image
        src={isUsSite ? '/next/assets/images/us-flag.svg' : '/next/assets/images/ca-flag.svg'}
        alt="country flag"
        width={44}
        height={18}
        className={styles['country-flag-image']}
      />
      <span className={styles['country-name']}>
        {isUsSite ? CountryCodeList.UNITED_STATES : CountryCodeList.CANADA}
      </span>
    </>
  );

  // Render the desktop navigation menu with country switcher
  return (
    <DesktopNavigation
      items={[{
        id: 'country-switcher',
        buttonVariant: 'custom' as const,
        customTrigger: countrySwitcherTrigger,
        customContent: <CountrySwitcher />,
      }]}
      behavior={{
        dropdownTrigger: 'hover',
        closeOnOutsideClick: true,
        enableSubmenus: false,
        mobileExpandInline: false,
      }}
      showChevron={true}
    />
  );
};

export default CountrySwitcherSection; 